import { render, staticRenderFns } from "./LoadInformation.vue?vue&type=template&id=c9873dda"
import script from "./LoadInformation.vue?vue&type=script&lang=js"
export * from "./LoadInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports